import { render, staticRenderFns } from "./Memoirs.vue?vue&type=template&id=74d92ab3&scoped=true&"
import script from "./Memoirs.vue?vue&type=script&lang=js&"
export * from "./Memoirs.vue?vue&type=script&lang=js&"
import style0 from "./Memoirs.vue?vue&type=style&index=0&id=74d92ab3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d92ab3",
  null
  
)

export default component.exports